// Module
var code = "<react-component name=\"ManageWebsiteIntegrations\" props=\"{save: save, websiteData: website, websiteUrl: websiteUrl(), mobileAppSettings: mobileAppSettings}\"></react-component>\n";
// Exports
module.exports = code;